import {APP_INITIALIZER, LOCALE_ID} from '@angular/core';
import {
  defaultInterpolationFormat,
  I18NEXT_SERVICE,
  I18NextLoadResult,
  I18NextModule,
  ITranslationService
} from 'angular-i18next';
import Backend from 'i18next-http-backend';
import i18nextLanguageDetector from 'i18next-browser-languagedetector';
import {availableLanguages} from '../core.const';

/**
 * Dieser Code ist eine Konfigurationsdatei für die Integration von i18next und angular-i18next, um mehrsprachige Anwendungen zu erstellen.
 *
 * Die Funktion appInit wird definiert, welche eine Instanz von i18next initialisiert und konfiguriert. Dabei werden verschiedene Einstellungen vorgenommen, z.B. welche Sprachen unterstützt werden sollen, welche Sprache als Fallback verwendet werden soll und wo sich die Übersetzungsdateien befinden. Darüber hinaus wird das Spracherkennungs-Plugin konfiguriert, um die vom Benutzer bevorzugte Sprache zu erkennen.
 */
export function appInit(i18next: ITranslationService) {
  return () => i18next
    .use(i18nextLanguageDetector)
    .use(Backend)
    .init({
      supportedLngs: availableLanguages,
      fallbackLng: 'de',
      debug: false,
      returnEmptyString: false,
      ns: ['translations'],
      defaultNS: 'translations',
      interpolation: {
        escapeValue: false,
        format: I18NextModule.interpolationFormat(defaultInterpolationFormat)
      },
      backend: {
        loadPath: '../../../../assets/locales/{{lng}}.{{ns}}.json',
      },
      detection: {
        // order and from where user language should be detected
        order: ['cookie', 'navigator'],

        // name of the language cookie
        lookupCookie: 'lang',

        // cache user language on
        caches: ['cookie'],

        // optional expire and domain for language cookie
        cookieMinutes: 10080 // 7 days
      }
    });
}


export function localeIdFactory(i18next: ITranslationService): string {
  return i18next.language;
}

export const I18N_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: appInit,
    deps: [I18NEXT_SERVICE],
    multi: true
  },
  {
    provide: LOCALE_ID,
    deps: [I18NEXT_SERVICE],
    useFactory: localeIdFactory
  }
];
